// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__1N0cA","main":"Footer_main__kopKK","names":"Footer_names__3kbJr"};